import { MutationTree } from 'vuex';
import {
    GET_USER_TRANSACTIONS_SUCCESS,
    GET_USER_TRANSACTIONS_ERROR,
    GET_USER_TRANSACTIONS,
    GET_USER_INFO,
    GET_USER_INFO_SUCCESS,
    GET_USER_INFO_ERROR,
} from './constants';
import {DetailInfo, ProfileState, Transaction} from './types';

const mutations = {
    [GET_USER_TRANSACTIONS](state: ProfileState) {
        state.transactions.list = [];
        state.transactions.error = false;
        state.transactions.loading = true;
    },
    [GET_USER_TRANSACTIONS_SUCCESS](state: ProfileState, transactions: Transaction[]) {
        state.transactions.list = transactions;
        state.transactions.error = false;
        state.transactions.loading = false;
    },
    [GET_USER_TRANSACTIONS_ERROR](state: ProfileState) {
        state.transactions.list = undefined;
        state.transactions.error = true;
        state.transactions.loading = false;
    },
    [GET_USER_INFO](state: ProfileState) {
        state.info.details = undefined;
        state.info.error = false;
        state.info.loading = true;
    },
    [GET_USER_INFO_SUCCESS](state: ProfileState, data: DetailInfo) {
        state.info.details = data;
        state.info.error = false;
        state.info.loading = false;
    },
    [GET_USER_INFO_ERROR](state: ProfileState) {
        state.info.details = undefined;
        state.info.error = true;
        state.info.loading = false;
    },
} as MutationTree<ProfileState>;

export default mutations;
